import React, { useEffect } from 'react'
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { fade, makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings'
import HistoryIcon from '@material-ui/icons/History'
import LockIcon from '@material-ui/icons/Lock'
import GroupIcon from '@material-ui/icons/Group'
import GroupWorkIcon from '@material-ui/icons/GroupWork'
import ShareIcon from '@material-ui/icons/Share'
import EmoteIcon from '@material-ui/icons/InsertEmoticon'
import FileCopyIcon from "@material-ui/icons/FileCopy"
import TimerIcon from '@material-ui/icons/Timer'
import PaletteIcon from '@material-ui/icons/Palette'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import ListIcon from '@material-ui/icons/List'
import KeyboardIcon from "@material-ui/icons/Keyboard"
import ZoomIcon from "@material-ui/icons/ZoomIn"
import ImageIcon from "@material-ui/icons/Image"
import BarChartIcon from "@material-ui/icons/BarChart"
import LocationCityIcon from '@material-ui/icons/LocationCity'
import StyleIcon from '@material-ui/icons/Style'
import LineWeightIcon from '@material-ui/icons/LineWeight'
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone'
import LinkOffIcon from '@material-ui/icons/LinkOff'
import { appName } from '../util/util'

const useStyles = makeStyles((theme) => ({
    page: {
        height: '100%',
        overflowY: 'auto',
        boxSizing: 'border-box',
        textAlign: 'left',
    },
    card: {
        display: 'block',
        maxWidth: 560,
        margin: theme.spacing(4, 6, 6, 6),
        padding: theme.spacing(3, 4, 4),
        textAlign: 'left',
        '&&': {
            backgroundColor: fade(theme.palette.background.paper, 0.5),
            backgroundImage: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(2, 2, 4, 2),
            padding: theme.spacing(2.5, 2.5, 3),
        },
    },
    version: {
        marginTop: theme.spacing(3),
        '&:first-of-type': {
            marginTop: theme.spacing(2),
        },
    },
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '4px 0',
    },
    icon: {
        display: 'inline-flex',
        marginRight: 12,
        opacity: 0.9,
    },
}))

export default function Changelog() {
    const classes = useStyles()

    useEffect(() => {
        document.title = `${appName} - What's New?`
    }, [])

    class ChangelogItem {
        constructor(public title: string, public icon: JSX.Element) { }
    }

    let items_3_0_0: ChangelogItem[] = [
        new ChangelogItem("Backgrounds Overhaul", <ImageIcon fontSize="small" />),
        new ChangelogItem("City Background", <LocationCityIcon fontSize="small" />),
        new ChangelogItem("Custom Cards", <StyleIcon fontSize="small" />),
        new ChangelogItem("Card Outlines", <LineWeightIcon fontSize="small" />),
        new ChangelogItem("Settings Improvements", <SettingsIcon fontSize="small" />),
        new ChangelogItem("Mobile Layout Improvements", <PhoneIphoneIcon fontSize="small" />),
        new ChangelogItem("Ping Timeout Adjustments", <TimerIcon fontSize="small" />),
        new ChangelogItem("Keep Result Cards After Disconnect", <LinkOffIcon fontSize="small" />),
        new ChangelogItem("More Emotes", <EmoteIcon fontSize="small" />),
    ]

    let items_2_2_0: ChangelogItem[] = [
        new ChangelogItem("Copy Result", <FileCopyIcon fontSize="small" />)
    ]

    let items_2_1_0: ChangelogItem[] = [
        new ChangelogItem("Timers", <TimerIcon fontSize="small" />)
    ]

    let items_2_0_0: ChangelogItem[] = [
        new ChangelogItem("New Animations", <VisibilityIcon fontSize="small" />),
        new ChangelogItem("Themed Logo Color", <PaletteIcon fontSize="small" />),
        new ChangelogItem("Spectator Mode", <GroupIcon fontSize="small" />),
        new ChangelogItem("Mean/Median Results", <BarChartIcon fontSize="small" />),
        new ChangelogItem("Unanimous Vote Indicator", <GroupWorkIcon fontSize="small" />),
        new ChangelogItem("Edit Room", <SettingsIcon fontSize="small" />),
        new ChangelogItem("Custom Voting Schemes", <ListIcon fontSize="small" />),
        new ChangelogItem("Anonymous Mode", <VisibilityOffIcon fontSize="small" />),
        new ChangelogItem("Lock Room", <LockIcon fontSize="small" />),
        new ChangelogItem("Vote History", <HistoryIcon fontSize="small" />),
        new ChangelogItem("Copy Link", <ShareIcon fontSize="small" />),
        new ChangelogItem("Emote Reactions", <EmoteIcon fontSize="small" />),
        new ChangelogItem("Free Response Mode", <KeyboardIcon fontSize="small" />),
        new ChangelogItem("Click Card to Enlarge", <ZoomIcon fontSize="small" />),
        new ChangelogItem("Animated Backgrounds", <ImageIcon fontSize="small" />),
        new ChangelogItem("Changelog Page", <ListIcon fontSize="small" />),
    ]

    function renderVersion(number: string, items: ChangelogItem[]) {
        return <div className={classes.version}>
            <Typography variant="h6" align="left" gutterBottom>{number}</Typography>
            <ul className={classes.list}>
                {items.map(item =>
                    <li key={item.title} className={classes.item}>
                        <span className={classes.icon}>
                            {item.icon}
                        </span>
                        <Typography variant="body1" align="left">{item.title}</Typography>
                    </li>
                )}
            </ul>
        </div>
    }

    return (
        <div className={classes.page}>
            <Paper className={classes.card} elevation={4}>
                <Typography variant="h5" align="left">What's New?</Typography>

                {renderVersion("3.0.0", items_3_0_0)}
                {renderVersion("2.2.0", items_2_2_0)}
                {renderVersion("2.1.0", items_2_1_0)}
                {renderVersion("2.0.0", items_2_0_0)}
            </Paper>
        </div>
    )
}
